import { useNavigate } from 'react-router-dom';
import ActionLinkButton from '../../UI/ActionLinkButton/ActionLinkButton';
import './backButton.scss';

type BackButtonProps = {
    absolute?: boolean;
};

const BackButton: React.FC<BackButtonProps> = ({ absolute = false }) => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <ActionLinkButton
            onClick={handleBackClick}
            ariaLabel="Назад"
            iconAlt="Назад"
            iconSrc="/icons/mobile/arrow-left.svg"
            iconSrcDark="/icons/mobile/arrow-left_w.svg"
            className="backButton__mobBtn"
        />
    );
};
export default BackButton;
